import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader, EmptyState, CaptureThumb } from "@/components/common";
import { FolderOpen } from "@/lib/icons";

export default function CollectionDetail() {
  const { id } = useParams();
  const [col, setCol] = useState(null);
  useEffect(() => { api.get(`/collections/${id}`).then((r) => setCol(r.data)).catch(() => {}); }, [id]);
  if (!col) return <div className="text-slate-500">Loading…</div>;
  return (
    <div className="max-w-6xl mx-auto">
      <PageHeader eyebrow={col.kind} color={col.color} title={col.name}
        subtitle={col.description || `${col.item_count} items`} />
      {col.captures.length === 0 ? (
        <EmptyState icon={FolderOpen} title="Empty collection" hint="Open a capture and use Connect → Add to collection to fill this." />
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
          {col.captures.map((c) => <CaptureThumb key={c.id} cap={c} />)}
        </div>
      )}
    </div>
  );
}
